var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfirmCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.7781 7.95547C56.6487 3.69171 63.3513 3.69171 67.2218 7.95547C69.8877 10.8922 74.0664 11.9221 77.7917 10.5607C83.2004 8.58407 89.1352 11.6989 90.5809 17.273C91.5767 21.1122 94.7981 23.9661 98.7293 24.4919C104.437 25.2552 108.245 30.7713 106.934 36.3788C106.032 40.241 107.558 44.2651 110.795 46.5575C115.494 49.8859 116.302 56.5396 112.536 60.8959C109.942 63.8963 109.423 68.1687 111.223 71.7027C113.838 76.8337 111.461 83.1007 106.102 85.2078C102.41 86.6591 99.9656 90.201 99.9175 94.1669C99.8478 99.925 94.8308 104.37 89.1063 103.745C85.1635 103.315 81.3527 105.315 79.4671 108.804C76.7294 113.87 70.2216 115.474 65.4431 112.261C62.1519 110.047 57.8481 110.047 54.5569 112.261C49.7784 115.474 43.2706 113.87 40.5329 108.804C38.6473 105.315 34.8365 103.315 30.8937 103.745C25.1692 104.37 20.1522 99.925 20.0825 94.1669C20.0344 90.201 17.5896 86.6591 13.8984 85.2078C8.53922 83.1007 6.16245 76.8337 8.77662 71.7027C10.5771 68.1687 10.0584 63.8963 7.46443 60.8959C3.69831 56.5396 4.50621 49.8859 9.20543 46.5575C12.442 44.2651 13.9682 40.241 13.0657 36.3788C11.7554 30.7713 15.5629 25.2552 21.2707 24.4919C25.2019 23.9661 28.4233 21.1122 29.4191 17.273C30.8648 11.6989 36.7996 8.58407 42.2083 10.5607C45.9336 11.9221 50.1123 10.8922 52.7781 7.95547Z",
    fill: "#E8F3EC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7595 45.7402L52.0395 73.4602L39.4395 60.8602",
    stroke: "#15803D",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmCheck);
export default __webpack_public_path__ + "static/media/confirmCheck.7d0a1bb678202d31401e699139f06840.svg";
export { ForwardRef as ReactComponent };